import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderSlot as _renderSlot, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["id"]
const _hoisted_2 = {
  key: 0,
  class: "dialog-title"
}
const _hoisted_3 = {
  key: 0,
  class: "text-left"
}
const _hoisted_4 = {
  key: 1,
  class: "dialog-title"
}
const _hoisted_5 = { class: "text-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Icon = _resolveComponent("Icon")!

  return (_openBlock(), _createElementBlock("div", {
    id: _ctx.id,
    class: _normalizeClass(["dialog-container", { visible: _ctx.isVisible }])
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(["dialog", [_ctx.size, { scrollable: _ctx.scrollable }]])
    }, [
      (_ctx.dismissible)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createVNode(_component_Icon, {
              class: "dialog-close-icon",
              name: "close",
              onClick: _ctx.hide
            }, null, 8, ["onClick"]),
            (_ctx.title)
              ? (_openBlock(), _createElementBlock("h3", _hoisted_3, _toDisplayString(_ctx.title), 1))
              : _createCommentVNode("", true)
          ]))
        : (_ctx.title)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createElementVNode("h3", _hoisted_5, _toDisplayString(_ctx.title), 1)
            ]))
          : _createCommentVNode("", true),
      _renderSlot(_ctx.$slots, "default")
    ], 2)
  ], 10, _hoisted_1))
}